<template>
  <div class="col-12">
    <b-card class="mb-3">
      <b-col cols="12" md="12">
        <h5>{{ $lang.send_code_verfication_interview }}</h5>
        <b-form @submit.prevent="getCode">
          <b-form-group>
            <b-input-group>
              <b-form-input
                type="text"
                class="input-style-offres w-75"
                :autocomplete="$lang.code"
                v-model="$v.code.$model"
                :state="$v.code.$dirty ? !$v.code.$error : null"
              >
              </b-form-input>

              <span v-if="code" @click="clear" key="fa-times ">
                <i class="fa fa-times remove_value" aria-hidden="true"></i>
              </span>

              <b-input-group-prepend>
                <b-button
                  class="btn-lightgray"
                  @click="getCode"
                  v-b-tooltip.hover
                  :title="$lang.search.search_tooltip"
                >
                  <i class="fa fa-search"></i>
                </b-button>
              </b-input-group-prepend>
              <div
                class="invalid-feedback"
                v-if="!$v.code.required"
                id="father_name-feedback"
              >
                {{ $lang.error_required | replace($lang.code) }}
              </div>
              <div class="invalid-feedback" v-if="!$v.code.numeric">
                {{ $lang.error_numeric | replace($lang.code) }}
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  $v.code.numeric && !$v.code.minLength | !$v.code.maxLengthl
                "
              >
                {{ $lang.error_max | replace($lang.code, 10) }}
              </div>
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-col>
    </b-card>
    <LoadingSpinner :loading="isLoading" />
    <b-col
      cols="12"
      md="12"
      class="bg-light border rounded my-3 py-3"
      v-if="!isLoading && virtual_interview_url"
    >
      <b v-text="$lang.virtual_interview_url" />
      <div
        class="border rounded d-flex align-items-center justify-content-between p-2 bg-white mt-2"
      >
        <span
          @click="copy(virtual_interview_url, true)"
          v-b-tooltip.hover
          title="کپی"
        >
          <i class="fas fa-clipboard fa-lg text-dark cursor_pointer" />
        </span>
        <a
          :href="virtual_interview_url"
          target="_blank"
          v-text="virtual_interview_url"
        />
      </div>
    </b-col>
    <b-col
      cols="12"
      v-if="Object.keys(audience).length > 0 && !isLoading"
      class="px-0 mt-2"
    >
      <b-overlay :opacity="1" :show="show_modal" rounded="sm">
        <template #overlay>
          <br />
        </template>
        <b-card>
          <div slot="header">
            <b-row>
              <b-col cols="12"> صفحه مصاحبه متقاضی </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col cols="12" class="mb-3">
              <interviewAudienc :audience="audienceInfo" :img_kind="img_kind" />
            </b-col>
            <b-col cols="12" class="mb-3">
              <b-card class="width-percent-100" :no-body="true">
                <div
                  class="flex justify-content-between align-items-center"
                  slot="header"
                >
                  <span>{{ $lang.doVoiveRecord }}</span>

                  <AudioRecorderNew
                    :uploadUrl="uploadUrl"
                    :attachmentTypeId="29"
                    attachmentTypeName="attachment_type_interview"
                    :caption="generateFileCaption"
                    :isDisabled="!interview_master || !audience_parvandeh_code"
                  />
                </div>
              </b-card>
            </b-col>
            <b-col class="my-3" cols="12" v-show="interview_complete == 1">
              <div class="text-center">
                <strong class="text-danger">
                  به علت پایان مصاحبه امکان مشاهده و ویرایش پرسشنامه‌ها وجود
                  ندارد</strong
                >
              </div>
            </b-col>
            <b-col cols="12" v-show="interview_complete == 0">
              <Alert
                class="margin-bottom-8"
                :text="$lang.completeExamPacksForAudience"
              />
              <ul class="margin-0 list-style--none">
                <li
                  class="width-percent-100 text-left margin-bottom-16"
                  :key="index + `research`"
                  v-for="(button, index) in buttons_exampack"
                >
                  <a
                    class="text-decoration-underline"
                    :href="button.address"
                    target="_blank"
                  >
                    {{
                      `${index + 1}- ${pathOr(
                        "",
                        ["exam_pack", "name"],
                        button
                      )}`
                    }}
                  </a>
                </li>
              </ul>
            </b-col>
            <b-col class="my-4" cols="12" v-show="interview_complete == 0">
              <!-- <audioReco
                v-show="interview_master && audience_parvandeh_code"
                :audience_code="item_star_id"
                :interview_master_name="interview_master_name"
                :name="`${audience_parvandeh_code}_${interview_master}`"
                @getUploadFile="getUploadFile"
                @startRecording="startRecording"
              /> -->
              <!-- <AudioRecorder
                :attachmentTypeId="29"
                :attachmentTypeName="'attachment_type_interview'"
                :afterUploadService="handleCreateAttachment"
                :successfullyMessage="$lang.successfullySendedAudio"
                :caption="generateFileCaption"
                :shouldSendExtraData="true"
                :isDisabled="!interview_master || !audience_parvandeh_code"
              /> -->
            </b-col>
            <b-col class="mt-2" cols="12" md="12">
              <uploadFile
                v-if="item_star_id && load"
                :allowCollapse="true"
                :file_types="file_types"
                keyServies="interview_done"
                :keyValue="item_star_id"
                attachmentRoute="attachment_interview_doing"
                :outParams="getOutParams('attachment_type_interview')"
                :parentPermissions="parentPermissions"
                :parentUploadFile="false"
                :parent_attachment_type_options="attachment_type_interview"
                :propAttachmentType="true"
                title="پیوست‌ها"
                :topAlert="$lang.uploadFileTitle"
                :dynamicParentBtn="dynamicParentBtn"
                :maxUploadFile="10485760"
                :acceptFormats="acceptFormats"
                :allowFileSize="10240"
              />
            </b-col>
            <b-col cols="12" md="12" class="mt-2 px-0">
              <uploadFile
                title="فایل‌ها"
                :keyServies="`person`"
                :keyValue="audience_person_code"
                :file_types="file_types"
                :customPermission="['view']"
                :allowCollapse="true"
                :isCollapseFiles="true"
                :parentUploadFile="true"
                :dynamicParentBtn="dynamicParentBtn"
                :maxUploadFile="10485760"
                :allowFileSize="10240"
                :acceptFormats="acceptFormats"
                attachmentRoute="attachment_person"
                :outParams="getOutParams('attachment_type_person')"
              />
            </b-col>
            <b-col v-show="item_star_id" class="text-right mt-3" cols="12">
              <b-button
                @click="patchInterview(1)"
                class="mr-2 col-12 col-md-3"
                size="md"
                type="button"
                v-if="interview_complete == 0"
                variant="success"
              >
                <div v-if="!isBtnLoading">
                  {{ $lang.interview_complete }}
                  <span key="fa-check"><i class="fa fa-check"></i></span>
                </div>
                <div v-if="isBtnLoading">
                  <b-spinner small></b-spinner>
                  <span> {{ $lang.search.loading_send }}</span>
                </div>
              </b-button>
              <b-button
                :disabled="isBtnLoading"
                @click="patchInterview(0)"
                class="text-center col-12 col-md-3"
                v-if="interview_complete == 1 && roles.includes('modir_system')"
                variant="danger"
              >
                <div v-if="!isBtnLoading">
                  {{ $lang.interview_complete_back }}
                  <span key="fa-ban"><i class="fa fa-ban"></i></span>
                </div>
                <div v-if="isBtnLoading">
                  <b-spinner small></b-spinner>
                  <span> {{ $lang.search.loading_send }}</span>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-overlay>
    </b-col>
    <confirm
      :cancel-title="$lang.no"
      :description="message"
      :ok-title="$lang.yes"
      :title="confirmTitle"
      @cancel="notchangeState"
      @ok="changeState"
      v-model="state"
    ></confirm>
  </div>
</template>

<script>
import { AudioRecorderNew, Alert } from "@/components/re-design";
import { required } from "vuelidate/lib/validators";
import confirm from "@/components/base/confirm";
import uploadFile from "@/components/base/uploadFile";
import interviewAudienc from "../components/interviewAudienc";
import { pathOr } from "ramda";
import {
  renderEumOptions,
  copy,
  generateLang,
  generateError,
  getCurrentDateTime,
  generateStoreGetters,
  generateApiUrl,
} from "@/shared/utils";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { createInterviewDoneAttachment } from "@/modules/interview/services";

export default {
  validations: {
    code: {
      required,
    },
  },
  components: {
    uploadFile,
    confirm,
    interviewAudienc,
    LoadingSpinner,
    AudioRecorderNew,
    Alert,
  },
  inject: [
    "interviewAzmoonExecutePersonRepository",
    "interviewDoingRepository",
    "attachmentRepository",
  ],
  data() {
    return {
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      load: true,
      filesLoading: false,
      state: false,
      confirmTitle: "",
      message: "",
      isBtnLoading: false,
      img_kind: null,
      url: null,
      audience_parvandeh_code: null,
      view_interview: false,
      hiddenFields: [],
      show_modal: false,
      buttons_exampack: [],
      code: null,
      interview_complete: null,
      interview_master_name: null,
      itemId: null,
      azmoon_execute_id: null,
      interview_master: null,
      flakUploadFile: false,
      parentPermissions: ["admin"],
      permissions: [],
      audience: {},
      item_star_id: null,
      virtual_interview_url: null,
      interview_location_person_audience_id: null,
      file_types: ["image", "office", "media", "other"],
      parent_attachment_type_options: [
        {
          text: "ضمیمه مصاحبه",
          value: 21,
        },
      ],
      isLoading: false,
      showComponents: false,
      interviewId: null,
      interview_master_person_code: null,
      audienceInfo: {},
      hasAttachment: false,
    };
  },
  computed: {
    attachment_type_interview() {
      return renderEumOptions("attachment_type_interview");
    },
    uploadUrl() {
      return generateApiUrl(
        ["interview", "interviewDoneAttachment"],
        [this.item_star_id]
      );
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]);
    },
    generateFileCaption() {
      const currentDateTime = getCurrentDateTime();
      return `${generateLang(["interviewAudioByMaster"])} ${
        this.interview_master_name
      } (${currentDateTime})`;
    },
  },
  methods: {
    renderEumOptions,
    copy,
    pathOr,
    dynamicParentBtn(x) {
      let buttons = [];
      if (x.confirm_type && x.confirm_type.id == 1) {
        buttons = [
          {
            id: "3",
            name: "edit",
          },
        ];
      } else {
        if (x.type.match("image")) {
          buttons = [
            {
              id: "0",
              name: "delete",
            },
            {
              id: "1",
              name: "edit",
            },
            {
              id: "2",
              name: "crop",
            },
          ];
        } else {
          buttons = [
            {
              id: "1",
              name: "edit",
            },
          ];
        }
      }

      return buttons;
    },
    startRecording() {
      this.showComponents = true;
    },
    async handleCreateAttachment(tempFile) {
      try {
        const files = [tempFile];
        const response = await createInterviewDoneAttachment(
          this.item_star_id,
          files
        );
        this.getUploadFile();
        return response;
      } catch (error) {
        generateError(error);
      }
    },
    getUploadFile() {
      this.load = false;
      this.flakUploadFile = true;
      this.hasAttachment = true;

      setTimeout(() => {
        this.load = true;
      }, 1000);
    },
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    /* async postInterviewStart(item) {
      try {
        let payload = {
          interview_location_person_master_id:
            item.interview_location_person_master_id,
        };
        let id = item.interview_location_person_id;
        const url =
          this.$config.api_url +
          this.$config.interview.interview_start.replace("{0}", id);
        const response = await this.$httpService.post(url, payload);
        this.item_star_id = response.data.data.interview_done_id;
      } catch (error) {
        this.$generateError(error);
      }
    }, */
    async patchInterview(item) {
      this.confirmTitle = "تایید پایان مصاحبه";
      if (item) {
        this.message = this.flakUploadFile
          ? this.$lang.confirm_interview_complete
          : this.$lang.confirm_interview_uploadFile;
        this.state = true;
      } else {
        this.changeState();
      }
    },
    async changeState() {
      try {
        this.isBtnLoading = true;
        let payload = {
          interview_complete: this.interview_complete === 0 ? 1 : 0,
        };
        const response = await this.interviewDoingRepository.partial_edit(
          this.item_star_id,
          payload
        );
        this.$notify.success(response.data.message);
        this.clear();
      } catch (err) {
        this.$generateError(err);
      } finally {
        this.state = false;
        this.isBtnLoading = false;
      }
    },
    notchangeState() {
      this.changeStateItem = null;
      this.state = false;
      this.message = "";
    },
    close() {
      this.$router.push("/");
    },
    async getResearchAzmoonExecutePerson() {
      if (this.azmoon_execute_id && this.interview_master) {
        const azmoonId = this.azmoon_execute_id;
        const audience_parvandeh_code = this.audience_parvandeh_code;
        const master_parvandeh_code = this.interview_master;
        const reference_person_code = this.audience_person_code;
        try {
          const response =
            await this.interviewAzmoonExecutePersonRepository.list(
              azmoonId,
              audience_parvandeh_code,
              master_parvandeh_code,
              reference_person_code
            );
          this.buttons_exampack = pathOr([], ["data", "data"], response);
        } catch (err) {
          this.$generateError(err);
        }
      } else {
        this.$notify.error("آزمونی وجود ندارد");
      }
    },
    clear() {
      this.img_kind = null;
      this.code = null;
      this.audience = {};
    },
    async getCode() {
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.interview.interview_doing.replace("{0}", this.code);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);

        this.show_modal = false;
        this.audience = pathOr(null, ["audience"], data);
        this.audienceInfo = {
          ...pathOr(null, ["audience", "person"], data),
          parvandehCode: pathOr(null, ["parvandeh", "code"], this.audience),
          parvandehNumber: pathOr(
            null,
            ["parvandeh", "parvandeh_number"],
            this.audience
          ),
        };
        this.virtual_interview_url = pathOr(
          null,
          ["interview_master", "person", "virtual_interview_url"],
          data
        );
        this.audience_parvandeh_code = pathOr(
          null,
          ["parvandeh", "code"],
          this.audience
        );
        this.audience_person_code = pathOr(
          null,
          ["person", "code"],
          this.audience
        );
        this.itemId = pathOr(null, ["interview_location_person_id"], data);
        this.interview_complete = pathOr(null, ["interview_complete"], data);
        //  اعلام شروع ضبط صدا بعد از زدن این فلک شروع به کار می کند
        this.showComponents = !!this.interview_complete;
        this.interview_location_person_audience_id = pathOr(
          null,
          ["interview_location_person_audience_id"],
          data
        );
        this.img_kind = pathOr(
          null,
          ["person", "attachment", "url"],
          this.audience
        );

        this.azmoon_execute_id = pathOr(null, ["azmoon_execute_id"], data);
        this.interview_master = pathOr(
          null,
          ["interview_master", "parvandeh", "code"],
          data
        );
        this.interview_master_person_code = pathOr(
          null,
          ["interview_master", "person", "code"],
          data
        );

        this.interview_master_name = pathOr(
          null,
          ["interview_master", "person", "full_name"],
          data
        );
        this.hasAttachment = pathOr(
          false,
          ["interview_master", "has_attachment"],
          data
        );
        this.interviewId = pathOr(null, ["interview_location_person_id"], data);
        this.item_star_id = pathOr(null, ["interview_done_id"], data);

        this.permissions = response.data.permissions;
        if (data) {
          !this.interview_complete && this.getResearchAzmoonExecutePerson();
          // this.postInterviewStart(data);
        }
      } catch (error) {
        this.$generateError(error);
        this.clear();
      } finally {
        this.isLoading = false;
        this.isBtnLoading = false;
      }
    },
    availableButtons(item) {
      return this.buttons.filter((x) =>
        x.is_confirmed.includes(item.is_confirmed)
      );
    },
    cancel() {
      this.view_interview = false;
      this.$refs.interviewDoing.getItems();
    },
    AddInterview() {
      this.view_interview = true;
    },
    getOutParams(key) {
      return {
        attachment_type_id: renderEumOptions(key).map((item) => item.value),
      };
    },
  },
};
</script>

<style>
.open-tab {
  animation: open 1s;
}

.detail_body {
  display: block;
}

.text_details {
  cursor: pointer;
  color: red;
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.ar {
  width: 100% !important;
  font-family: "Roboto", sans-serif;
  border-radius: 16px;
  background-color: #fafafa;
  box-shadow: 0 4px 18px 0 rgb(0 0 0 / 17%);
  position: relative;
  box-sizing: content-box;
  margin: auto !important;
}

.ar-player {
  width: 80% !important;
  display: none !important;
}

.ar-player > .ar-player-bar {
  width: 100% !important;
}

.ar-icon__lg {
  line-height: 33px !important;
}

.ar-icon__sm {
  line-height: 17px !important;
}

.ar-records {
  height: auto !important;
}
</style>
